module.exports = __webpack_public_path__ + "static/media/focus-remi-lombard.95d33035.jpg";